import * as React from 'react';
import style from './SearchButton.scss';
import { Text } from '../../PageElements/Text';
import Search from 'wix-ui-icons-common/Search';
import { SearchShortcutIcon } from '../../PageElements/svgs';
import classnames from 'classnames';
import { StoreContext } from '../../../appContext/StoreProvider';

export const SearchButton = ({ openModal }) => {
  const { store } = React.useContext(StoreContext);
  const hasRelatedSites = store.viewer?.viewerConfig?.relatedSites?.length > 1;

  return (
    <div
      data-hook="open-search-modal-btn"
      className={classnames({
        [style.searchModalBtn]: true,
        [style.withoutRelatedSites]: !hasRelatedSites,
      })}
      onClick={openModal}
    >
      <Search className={style.searchIcon} width="18px" height="18px" />
      <Text
        tagName="span"
        size="tiny"
        weight="normal"
        secondary
        className={style.searchText}
      >
        Search...
      </Text>

      <span className={style.shortcut}>
        <SearchShortcutIcon />
      </span>
    </div>
  );
};
